import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { of } from 'rxjs'
import { concatMap, toArray } from 'rxjs/operators'
import { TaskAccessResponse, CreateTaskAccessPayload, UpdateTaskAccessPayload } from './model'

@Injectable({
  providedIn: 'root',
})
export class TaskAccessService {
  constructor(private http: HttpClient) {}

  all() {
    const url = '@api/taskaccess/all/'

    return this.http.get<TaskAccessResponse[]>(url)
  }

  add(payload: CreateTaskAccessPayload) {
    const url = '@api/taskaccess/'
    return this.http.post<TaskAccessResponse>(url, payload)
  }

  delete(id: string) {
    const url = `@api/taskaccess/delete/${id}`

    return this.http.delete<TaskAccessResponse>(url)
  }

  deleteMultiple(ids: string[]) {
    return of(...ids).pipe(
      concatMap((id) => this.delete(id)),
      toArray()
    )
  }

  update(id: string, payload: UpdateTaskAccessPayload) {
    const url = `@api/taskaccess/${id}`

    return this.http.put<TaskAccessResponse>(url, payload)
  }

  archive(id: string) {
    const url = `@api/taskaccess/${id}`
    return this.http.put<TaskAccessResponse>(url, { archived: 1 })
  }

  archiveTasks(ids: string[]) {
    return of(...ids).pipe(
      concatMap((id) => this.archive(id)),
      toArray()
    )
  }

  unarchive(id: string) {
    const url = `@api/taskaccess/${id}`
    return this.http.put<TaskAccessResponse>(url, { archived: 0 })
  }

  unarchiveTasks(ids: string[]) {
    return of(...ids).pipe(
      concatMap((id) => this.unarchive(id)),
      toArray()
    )
  }
}
